import curd from '../curd'

const BASE_PATH = '/configure/site'

export default curd(BASE_PATH, {
  getType: () => ({
    url: `${BASE_PATH}/type`,
    method: 'GET'
  }),
  update: data => ({
    url: `${BASE_PATH}/update`,
    method: 'PUT',
    data
  }),
  uploadSave: data => ({
    url: `${BASE_PATH}/upload/save`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Site.js